<template>
  <v-flex
    id="locationData"
    class="question"
  >
    <p class="required-block required-block_left">
      {{ $t('label.required_fields') }}
    </p>
    <h2 class="display-3 display-3_dark mb-1 py-0">
      {{ $t('warehouses.locationData.title') }}
    </h2>

    <p class="fw-600 f-1 required-block mb-0 mt-3">
      1. {{ $t('warehouses.locationData.warehouse_name') }}
    </p>
    <v-flex
      xs12
      sm6
    >
      <v-text-field
        v-model="warehouseName"
        v-validate="validationRules.get('warehouseName')"
        :error-messages="errors.collect('warehouseName')"
        :data-vv-as="' '"
        :data-vv-name="'warehouseName'"
        required
        auto-grow
        disabled
      />
    </v-flex>

    <warehouseAddress
      :warehouse-type="1"
      :read-only="readOnly"
      @emitAddress="getAddress($event)"
    />
    <openingHours
      :warehouse-type="1"
      :read-only="readOnly"
      @emitHours="getHours($event)"
    />
    <roadDirections
      :warehouse-type="1"
      :read-only="readOnly"
      @emitDirections="getDirections($event)"
    />
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import validationRules from '@/constants/validationRules';
import roadDirections from '@/components/widgets/warehouse/locationData/roadDirections';
import openingHours from '@/components/widgets/warehouse/locationData/openingHours';
import warehouseAddress from '@/components/widgets/warehouse/locationData/warehouseAddress';

import { createHelpers } from 'vuex-map-fields';

const { mapFields: mapNameField } = createHelpers({
    getterType: 'warehouses/getWarehouseNameField',
    mutationType: 'warehouses/updateWarehouseNameField'
});

const { mapFields: mapAddressFields } = createHelpers({
    getterType: 'warehouses/getWarehouseAddressFields',
    mutationType: 'warehouses/updateWarehouseAddressFields'
});

const { mapFields: mapHoursFields } = createHelpers({
    getterType: 'warehouses/getWarehouseOpeningFields',
    mutationType: 'warehouses/updateWarehouseOpeningFields'
});

export default {
    name: 'LocationData',
    components: { roadDirections, openingHours, warehouseAddress },
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            validationRules
        };
    },
    computed: {
        ...mapNameField(['warehouseName', 'directions']),
        ...mapAddressFields([
            'locationName',
            'street',
            'city',
            'flatNumber',
            'placeNumber',
            'province',
            'rejon',
            'postalCode'
        ]),
        ...mapHoursFields([
            'firstDayFrom',
            'firstDayTo',
            'secondDayFrom',
            'secondDayTo',
            'thirdDayFrom',
            'thirdDayTo',
            'additionalFirstDayChecked',
            'additionalThirdDayChecked'
        ]),
        xsOnly () {
            return this.$vuetify.breakpoint.xsOnly;
        },
        selectedRejon () {
            return this.$store.getters['warehouses/getSelectedRejon'];
        }
    },
    created () {
        this.warehouseName = this.selectedRejon.name;
    },
    methods: {
        getAddress (event) {
            this.locationName = event.locationName;
            this.street = event.street;
            this.city = event.city;
            this.flatNumber = event.flatNumber;
            this.placeNumber = event.placeNumber;
            this.province = event.province;
            this.rejon = event.rejon;
            this.postalCode = event.postalCode;
        },
        getHours (event) {
            this.additionalFirstDayChecked = event.additionalFirstDayChecked;
            this.additionalThirdDayChecked = event.additionalThirdDayChecked;
            this.firstDayFrom = event.firstDayFrom;
            this.firstDayTo = event.firstDayTo;
            this.secondDayFrom = event.secondDayFrom;
            this.secondDayTo = event.secondDayTo;
            this.thirdDayFrom = event.thirdDayFrom;
            this.thirdDayTo = event.thirdDayTo;
        },
        getDirections (event) {
            this.directions = event;
        }
    }
};
</script>

<style scoped></style>
